module.exports = __webpack_public_path__ + "img/home_popup_android.e8e6ecfa.png";